import { AppointmentData, TimeSlot } from "@/data/interfaces/Appointments";
import api from "./api";

type RezusPrefillData = {
  name?: string;
  email?: string;
  phone?: string;
};

type RezusLocation = {
  city: string;
  location: { id: string; name: string; phone: string };
};

async function getPrefillData(token: string): Promise<RezusPrefillData> {
  const resp = await api.get(`/rezus-registrations/${token}`);
  return resp.data.data;
}

async function getLocations(token: string): Promise<RezusLocation[]> {
  const resp = await api.get(`/rezus-registrations/${token}/cities`);
  return resp.data;
}

async function getAppointments(
  token: string,
  city?: string,
): Promise<AppointmentData[]> {
  const resp = await api.get(`/rezus-registrations/${token}/appointment`, {
    params: city ? { city } : undefined,
  });
  const data = resp.data.data;
  return Array.isArray(data) ? data : [data];
}

async function getSlots(
  token: string,
  payload: {
    location: number | string;
    service: number | string;
    worker: number | string;
    date: string;
  },
): Promise<TimeSlot[]> {
  const resp = await api.post(`/rezus-registrations/${token}/slots`, payload);
  return resp.data;
}

type RegistrationPayload = {
  location: number | string;
  location_name: string;
  service: number | string;
  service_name: string;
  worker: number | string;
  worker_name: string;
  date: string;
  start: string;
};

async function registerAppointment(
  token: string,
  payload: RegistrationPayload,
) {
  const resp = await api.post(
    `/rezus-registrations/${token}/register`,
    payload,
  );
  return resp.data;
}

export type { RezusPrefillData, RezusLocation };

export default {
  getPrefillData,
  getLocations,
  getAppointments,
  getSlots,
  registerAppointment,
};
